GloboSwatchConfig.settings = {
            enable_collection_page: false,
            enable_product_page: true,
            out_of_stock: "cross out",
            enable_mandatory: true,
            show_add_to_cart_button: true,
            add_to_cart_ajax: false,
            show_option_name: true,
            add_to_cart_text: "Add to cart",
            added_to_cart_text: "Added to cart",
            sold_out_text: "Sold out",
            text_required: "This field is required",
            sort_option: false,
            show_one_variant_product: true,
            show_one_variant_collection: false,
            group_image: false,
            show_limit_variant: false,
            limit_variant: "5",
        };
        GloboSwatchConfig.options = [{"id":54473,"name":"Size","shop_id":9715,"option_items":[{"id":1372922,"value":"1(XS)","option_id":54473,"products":null,"products_count":9,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1372923,"value":"2(S)","option_id":54473,"products":null,"products_count":8,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1372924,"value":"3(M)","option_id":54473,"products":null,"products_count":8,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1372925,"value":"4(L)","option_id":54473,"products":null,"products_count":8,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":3,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":9,"order":1},{"id":54474,"name":"Color","shop_id":9715,"option_items":[{"id":1372926,"value":"VANILLA","option_id":54474,"products":null,"products_count":9,"select_type":1,"custom":{"color_1":"#ffffdd","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1372927,"value":"GRAY","option_id":54474,"products":null,"products_count":7,"select_type":1,"custom":{"color_1":"#c0c0c0","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1372928,"value":"BLACK","option_id":54474,"products":null,"products_count":8,"select_type":1,"custom":{"color_1":"#000000","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1372929,"value":"WHITE","option_id":54474,"products":null,"products_count":6,"select_type":1,"custom":{"color_1":"#ffffff","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1372930,"value":"TOUPE","option_id":54474,"products":null,"products_count":6,"select_type":1,"custom":{"color_1":"#aa8886","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1372931,"value":"OLIVE","option_id":54474,"products":null,"products_count":6,"select_type":1,"custom":{"color_1":"#63794b","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":1,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":9,"order":2}];
        GloboSwatchConfig.product_page= {
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#000000',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#FFFFFF',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                show_number_stock: '',
                float: 'left'
            };
            GloboSwatchConfig.collection_page ={
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#0a0a0a',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#ffffff',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                float: 'left',
                carousel: 'disable'
        };